<template>
  <div class="allocated-orders">
    <div class="table-header mt-15">
      <h3>COMPLETED ORDER ALLOCATIONS:</h3>
    </div>

    <vue-good-table
        :columns="columns"
        :rows="rows"
        :sort-options="{
           enabled: false
        }"
    >
      <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field === 'info'" class="info-con">
       <span v-for="(item,index) in props.row.info" :key="index" class="info-item sk-info-item" :class="borderClass(index,props.row.info.length)">
                <span class="sk-info-item-title">{{ item.title }}</span>
                <span class="sk-info-item-qty">{{ item.qty }}</span>
              </span>
    </span>
        <span v-else-if="props.column.field === 'po'">
      <span v-if="props.row.po.po_required&&props.row.po.po_number">{{ props.row.po.po_number}}</span>
      <span v-else-if="props.row.po.po_required&&!props.row.po.po_number">...</span>
      <span v-else>not required</span>
    </span>
        <span v-else-if="props.column.field === 'update'">
              <button class="order-btn orange" v-on:click.prevent="()=>onUpdateItem(props.row.id)">Update</button>
          </span>
        <span v-else-if="props.column.field === 'delete'">
              <button class="order-btn red" v-on:click.prevent="()=>onDeleteItem(props.row.id)">Delete</button>
          </span>
        <span v-else>
      {{ props.formattedRow[props.column.field] }}
    </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table';
export default {
  name: 'AllocatedOrders',
  components:{
    VueGoodTable
  },
  props: {
    ordersData: Array,
    editable: {
      type:Boolean,
      default: false
    },
    onDeleteItem: Function,
    onUpdateItem: Function
  },
  data(){
    return{
      notEditableColumns: [
        {
          label: 'AID',
          field: 'aoId',
          type: 'string',
          width: '10%',
          sortable: false,
        },
        {
          label: 'Address',
          field: 'address',
          type: 'string',
          width: '30%'
        },
        {
          label: 'PO',
          field: 'po',
          type: 'string',
          width: '10%'
        },
        {
          label: 'Items Allocation Info',
          field: 'info',
          type: 'string',
          width: '40%',
          tdClass: 'sk-no-padding',
        }
      ],
      editableColumns: [
        {
          label: 'AO ID',
          field: 'aoId',
          type: 'string',
          width: '10%'
        },
        {
          label: 'Address',
          field: 'address',
          type: 'string',
          width: '26%'
        },
        {
          label: 'PO',
          field: 'po',
          type: 'string',
          width: '10%'
        },
        {
          label: 'Items Allocation Info',
          field: 'info',
          type: 'string',
          width: '45%',
          tdClass: 'sk-no-padding',
        },
        {
          label: 'Update',
          field: 'update',
          width: '10%'
        },
        {
          label: 'Delete',
          field: 'delete',
          width: '10%'
        }
      ],
    }
  },
  computed: {
    rows() {
      return this.ordersData.map((item,index)=>{
        // console.log(item);

        return {
          aoId: item.id,
          id: index,
          address: item.address,
          po: {
            po_required: item.po_required,
            po_number: item.po_number,
            poDate: item.poDate
          },
          info: item.allocationItems
        }
      });
    },
    columns(){
      return this.editable ? this.editableColumns : this.notEditableColumns;
    }
  },
  mounted() {
    // console.log(this.ordersData);
  },
  methods: {
    borderClass(index, infoLength){
      return index!==infoLength-1?'sk-border-bottom':''
    }
  }
}
</script>